import { MessageCircle } from "lucide-react";
import { CONTACT, useLang } from "@/i18n";

export default function WhatsAppFloat() {
  const { t } = useLang();
  return (
    <a
      data-testid="whatsapp-float-button"
      href={CONTACT.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      className="group fixed bottom-6 right-6 z-[80] flex items-center gap-2.5 rounded-full bg-obsidian py-3 pl-4 pr-5 text-paper shadow-[0_16px_40px_-12px_rgba(15,23,42,0.5)] transition-all duration-300 hover:bg-brand hover:text-obsidian"
    >
      <span className="relative flex h-6 w-6 items-center justify-center">
        <span className="absolute h-6 w-6 animate-ping rounded-full bg-[#10B981]/40 group-hover:bg-obsidian/20" />
        <MessageCircle className="h-5 w-5" />
      </span>
      <span className="font-mono hidden text-[11px] font-bold tracking-[0.15em] sm:block">{t.whatsappFloat}</span>
    </a>
  );
}
